import { render, staticRenderFns } from "./AreaDoAssociadoConfirmaCancelamento.vue?vue&type=template&id=07c3ae9e&"
import script from "./AreaDoAssociadoConfirmaCancelamento.vue?vue&type=script&lang=js&"
export * from "./AreaDoAssociadoConfirmaCancelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardText,VIcon})
